import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Rider, PagedRiders} from '../models/riders.model';
import { of } from 'rxjs';

@Injectable({
    providedIn: 'root'
  })
  export class RidersService {
    private url = `${environment.apiUrl}/riders`;
    

    constructor(private http: HttpClient) {}

    getRiders(page: number, limit: number, query?: string, vehicle_type?: number): Observable<PagedRiders> {
      let queryString = `page=${page}&limit=${limit}`;
      if (query) {
        queryString += `&search=${query}`;
      }
      if (vehicle_type) {
        queryString += `&vehicle_type=${vehicle_type}`;
      }
      return this.http.get<PagedRiders>(
        `${environment.apiUrl}/riders?${queryString}`
      );
    }


    createRider(rider: Rider): Observable<Rider> {
      console.log('try create rider', rider);
      return this.http.post<Rider>(this.url, rider);
    }

    editRider(rider: Rider): Observable<Rider> {
      // Crear una copia del objeto rider
      const riderToUpdate = { ...rider };
    
      // Eliminar las propiedades password y password_confirm si están vacías
      if (!riderToUpdate.password) {
        delete riderToUpdate.password;
      }
      if (!riderToUpdate.password_confirm) {
        delete riderToUpdate.password_confirm;
      }
      console.log('Rider enviado al servidor:', riderToUpdate);
    
      // Se hace la solicitud HTTP con el objeto modificado
      return this.http.put<Rider>(`${this.url}/${riderToUpdate.id}`, riderToUpdate);
    }

    deleteRider(id: number): Observable<Rider> {
        return this.http.delete<any>(`${this.url}/${id}`);
    }

    getRiderById(id: number): Observable<Rider> {
        return this.http.get<Rider>(`${this.url}/${id}`);
    }

    getRidersLocations(): Observable<any> {
      return this.http.get<any>(`${this.url}/location`);
    }
  }